module.exports = __webpack_public_path__ + "static/media/png.5269994c.svg";